<template>
  <div style="width: 100%; height: 100%">
    <RingPieEchart :chartData="chartData"></RingPieEchart>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionMedia",
  controller: "UI",
  action: "OpinionMedia",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      chartData: {
        data: [],
      },
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        BeginTime: new Date().format("yyyy-MM-dd 00:00"),
        EndTime: new Date().format("yyyy-MM-dd 23:59"),
      };
      new MyApis.OpinionApi()
        .GetMediaTop10(searchInfo)
        .then((r) => {
          r = r.data.Data;
          if (r && r.length > 0) {
            r.map((item) => {
              item.name = item.WebSiteName;
              item.value = parseInt(item.TotalCount);
            });
            this.chartData.data = r;
          }
          //  that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
  },
};
</script>